var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { EventEmitter } from '@ciceksepeti/cs-event-emitter';
import Gtm from '@constants/gtm';
import Events from '@constants/events';
import ResourceKeys from '@constants/resource-keys';
import { Pathname } from '@constants/metatags';
import CustomEvents from '@constants/custom-events';
import { useCommons } from '@hooks/use-commons';
import { getGtmCartData } from '@services/gtm';
var GoogleTagManagerScript = function (props) {
    var _a;
    var data = props.data;
    var value = data.value;
    var location = useLocation();
    var variables = useCommons().variables;
    var resources = variables.resources;
    var resource = ((_a = resources === null || resources === void 0 ? void 0 : resources.filter(function (_a) {
        var key = _a.key;
        return key === ResourceKeys.TITLE;
    })) !== null && _a !== void 0 ? _a : [])[0];
    var seoTitle = resource === null || resource === void 0 ? void 0 : resource.value;
    var dataLayerPushHandler = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var dataLayer, error_1, pageType;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    window.dataLayer = window.dataLayer || [];
                    if (!(location.pathname === Pathname.CHECKOUT_REGISTRATION ||
                        location.pathname === Pathname.CART)) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getGtmCartData()];
                case 2:
                    dataLayer = (_a.sent()).dataLayer;
                    window.dataLayer.push(__assign(__assign({}, dataLayer), { pageUrl: window.location.href, pageTitle: seoTitle !== null && seoTitle !== void 0 ? seoTitle : Gtm.DEFAULT_PAGE_TITLE }));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    if (location.pathname !== Pathname.POST_CHECKOUT) {
                        pageType = location.pathname === Pathname.ORDER_REVIEW ? Gtm.OTHER_PAGE_TYPE : Gtm.PAGE_TYPE;
                        window.dataLayer.push({
                            currency: Gtm.CURRENCY,
                            pageType: pageType,
                            cityInfo: Gtm.CITY_INFO,
                            ecomm_pagetype: pageType,
                            pageUrl: window.location.href,
                            pageTitle: seoTitle !== null && seoTitle !== void 0 ? seoTitle : Gtm.DEFAULT_PAGE_TITLE
                        });
                    }
                    _a.label = 6;
                case 6:
                    window.dataLayer.push({ event: CustomEvents.GTM_CLIENT_READY });
                    return [2 /*return*/];
            }
        });
    }); }, [location.pathname, seoTitle]);
    useEffect(function () {
        // We'll trigger the data layer push for the cart page and post checkout page in the useEffect below
        // using the event emitter
        if (location.pathname !== Pathname.CART && location.pathname !== Pathname.POST_CHECKOUT) {
            dataLayerPushHandler();
        }
    }, [dataLayerPushHandler, location.pathname]);
    useEffect(function () {
        var eventEmitter = new EventEmitter();
        eventEmitter.subscribe(Events.TRIGGER_DATA_LAYER_PUSH, dataLayerPushHandler);
        return function () {
            eventEmitter.unsubscribe(Events.TRIGGER_DATA_LAYER_PUSH, dataLayerPushHandler);
        };
    }, [dataLayerPushHandler]);
    return (_jsxs(Helmet, { children: [_jsx("script", { children: "window.dataLayer = window.dataLayer || [];" }), _jsx("script", { type: "text/javascript", children: "\n          setTimeout(function () {\n            (function (w, d, s, l, i) {\n              w[l] = w[l] || [];\n              w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });\n              var f = d.getElementsByTagName(s)[0],\n                j = d.createElement(s),\n                dl = l != 'dataLayer' ? '&l=' + l : '';\n              j.async = true;\n              j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;\n              f.parentNode.insertBefore(j, f);\n            })(window, document, 'script', 'dataLayer', '".concat(value, "');\n          }, 0);\n        ") }), _jsx("noscript", { children: "\n          <iframe\n            src=\"//www.googletagmanager.com/ns.html?id=".concat(value, "\"\n            height=\"0\"\n            width=\"0\"\n            style=\"display: none; visibility: hidden\"\n          ></iframe>\n        ") })] }));
};
export default GoogleTagManagerScript;
